import Utils from '../../modules/utils'

const getArtists = (getArtistsSuccess) => {
  Utils.get('artists', (err, res) =>
  {
    if (err) {
      alert('There was an error when trying to get the prints.')
    } else {
      getArtistsSuccess(res.data)
    }
  })
}

export {getArtists}
